import React, { useState, useEffect } from "react";
import { Row, Col, Spin, Icon, Select, Alert, Divider } from "antd";
import { useSelector } from "react-redux";
import intl from "react-intl-universal";
import {
  getReportByUser,
  // getReportByID,
} from "components/services/userLogService.js";
import style from "assets/css/ReportV2.module.scss";
import moment from "moment";
import "moment/locale/zh-hk";

/**
 * page name: 学生报告
 *
 * */

const Option = Select.Option;

const ReportV2 = ({ match }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState(null);
  const [comment, setComment] = useState("");
  // const [completionRate] = useState(100); // This should come from actual data
  // const [completedLevels] = useState(12); // This should come from actual data
  // const [totalLevels] = useState(16); // This should come from actual data
  const [playTime, setPlayTime] = useState(null); // This should come from actual data

  const translations = useSelector((state) => state.translations);

  useEffect(() => {
    moment.locale(intl.options.currentLocale);
  }, [intl.options.currentLocale]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getReportByUser();
        setData(response.rows);
        setSelected(response.rows[0].id);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching report data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (selected) {
      const _selected = data.find((item) => item.id === selected);
      setPlayTime(_selected.create_time);
      if (_selected.status === "DONE") {
        setComment(
          _selected.response
            .replace(/\n/g, "<br />")
            .replace("建議：", "<h1>建議：</h1>")
            .replace("報告：", "<h1>報告：</h1>")
        );
      } else {
        setComment(t("student_reports.generating"));
      }
    }
  }, [selected]);

  // Translation function
  const t = (key) => {
    return translations.initDone && intl.get(key);
  };
  // Mock data for the circular progress component
  const renderCircularProgress = (percentage) => {
    const strokeWidth = 18;
    const radius = 90;
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = circumference - (percentage / 100) * circumference;

    return (
      <div className={style.circularProgressContainer}>
        <svg width="200" height="200" viewBox="0 0 200 200">
          <circle
            cx="100"
            cy="100"
            r={radius}
            fill="none"
            stroke="#e6e6e6"
            strokeWidth={strokeWidth}
          />
          <circle
            cx="100"
            cy="100"
            r={radius}
            fill="none"
            stroke="#3DA9F5"
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            transform="rotate(0 100 100)"
          />
          <text
            x="100"
            y="90"
            textAnchor="middle"
            dy="8"
            fontSize="24"
            fontWeight="bold"
            fill="#333"
          >
            {t("student_reports.completion_progress")}
          </text>
          <text
            x="100"
            y="120"
            textAnchor="middle"
            dy="8"
            fontSize="24"
            fontWeight="bold"
            fill="#333"
          >
            {percentage}%
          </text>
        </svg>
      </div>
    );
  };

  if (loading) {
    return (
      <div className={style.loadingContainer}>
        <Spin
          indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
        />
      </div>
    );
  }

  return (
    <div className={style.reportContainer}>
      <Row type="flex" align="middle" justify="space-between">
        <Col>
          <Row
            className={style.selectContainer}
            type="flex"
            align="middle"
            justify="space-between"
          >
            <span className={style.title}>{t("student_reports.reportv2")}</span>
            <Select
              className={style.selector}
              defaultValue={selected}
              onChange={(val) => {
                setSelected(val);
              }}
              loading={!!loading}
              disabled={!!loading}
            >
              {(data || []).length === 0 && (
                <Option key="class-all" value={null}></Option>
              )}
              {(data || []).length > 0 &&
                data.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.course_name || item.course_id}
                  </Option>
                ))}
            </Select>
          </Row>
        </Col>
        {selected && (
          <Col style={{ fontSize: 20 }}>{`${t(
            "student_reports.last_played"
          )}${moment(playTime).calendar()}`}</Col>
        )}
        <Col
          xs={24}
          align="middle"
          style={{
            "text-align": "left",
            "font-weight": "bold",
            "margin-top": "20px",
            "font-size": "20px",
          }}
        >
          *本報告僅反映孩子於EVIGarten「挑戰站」的表現，只供參考，並不代表其在校的學習表現。
        </Col>
      </Row>
      <Divider />
      <React.Fragment>
        {(data || []).length === 0 && (
          <Row type="flex" align="middle">
            <Col xs={24}>
              <Row
                type="flex"
                align="middle"
                justify="center"
                style={{
                  minHeight: "calc(80vh - 200px)",
                }}
              >
                <span className={style.title}>
                  {t("student_reports.show_after_completion")}
                </span>
              </Row>
            </Col>
          </Row>
        )}
        {(data || []).length > 0 && (
          <Row type="flex" align="middle">
            <Col xs={24} md={9} lg={8} xl={6}>
              <Row type="flex" align="middle" justify="center">
                {renderCircularProgress(100)}
              </Row>
            </Col>
            <Col xs={24} md={15} lg={16} xl={18}>
              <div
                className={style.commentArea}
                dangerouslySetInnerHTML={{
                  __html: comment,
                }}
              ></div>
            </Col>
          </Row>
        )}
      </React.Fragment>
    </div>
  );
};

export default ReportV2;
